interface ArrowsUpSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ArrowsUpSVG = ({ color, style }: ArrowsUpSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
  >
    <g clipPath="url(#clip0_1284_1327)">
      <path
        d="M46.3387 51.2182V13.0305H51.2189L40.9529 0.779633L30.6869 13.0305H35.567V51.2182H28.9464V23.8317H18.1747V51.2182H11.552V34.6329H0.780273V51.2182"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1284_1327">
        <rect width="52" height="52" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ArrowsUpSVG;
